import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./PetFood.css";

const PetFood = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <section className="services-page">

        {/* Banner */}
        <div className="service-banner">
          <div className="overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1>Services</h1>
                <p>Quality nutrition and stylish accessories for your pets</p>
              </div>

              <div className="col-lg-6 text-end">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
                  alt="Pets"
                  className="img-fluid banner-pets"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Service Card */}
        <div className="service-section">
          <div className="container">

            <div className="service-card">
              <div className="row">
                <div className="col-md-5">
                  <div className="service-content">
                    <h1 className="font-bold mb-4">
                      Pet Food & Accessories
                    </h1>
                    <p className="font-semibold">
                      Quality nutrition and stylish accessories for your pets. We offer a curated selection of premium pet food, treats, toys, and accessories to keep your pet healthy and happy.
                    </p>
                    <p>
                      From specialized diets to fun toys, our products are carefully chosen to meet the highest standards of quality and safety for your beloved companions.
                    </p>
                    <a className="btn btn-dark rounded-pill px-4 w-50 mt-4 font-semibold py-2" href="/ServicesListing">
                      Back to Services
                    </a>
                  </div>
                </div>
                <div className="col-md-7 pe-0">
                  <div className="service-image">
                    <img
                      className="w-100"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/services_icon/pet-food.png`}
                      alt="Pet Food & Accessories"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </section>
    </>
  );
};

export default PetFood;
